/**
 * usePhones
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import PhonesContext from './phones-context'

const usePhones = () => {
  const context = useContext(PhonesContext)
  return context
}

export default usePhones
